import React from 'react'

// material ui
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import CardContent from '@mui/material/CardContent'

// components
import Typography from '@mui/material/Typography'
import Button from './Button'

export default function PreferencesCard(props) {
  const { form, onToggleCheckbox } = props

  return (
    <Card>
      <CardContent>
        <Typography variant='h6' gutterBottom>
          Camper Projects &amp; Photos
        </Typography>
        <FormControl>
          <FormControlLabel
            value='newProjectNotifications'
            checked={form.newProjectNotifications === 'true'}
            control={<Checkbox color='primary' />}
            onChange={onToggleCheckbox('newProjectNotifications')}
            label='Receive a daily email notification if new projects or photos are added'
            labelPlacement='end'
          />
        </FormControl>

        <Button {...props} />
      </CardContent>
    </Card>
  )
}
